import React, { Fragment, useState, useEffect } from "react";
import { Nav, NavItem, NavLink,Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table, TabContent, TabPane } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import ListProfesionals from './ListProfesionals';
import ProfesionalCollapse from './ProfesionalCollapse';
import classnames from 'classnames';
import Spinner from 'react-bootstrap/Spinner';
import ReportFees from './ReportFees';

const AllFees = ({ history, location }) => {

    const [profesionals, setProfesionals] = React.useState([]);
    const [thirds, setThirds] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState('1');

    const refresh = () => {
        listProfesionals();
    }

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    //Lista los Profesionales con sus Honorarios y Excepciones
    const listProfesionals = async () => {
        setIsLoading(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}honorarios/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setIsLoading(false);
            setProfesionals(data);
        }).catch((error) => {
            setIsLoading(false);
            setProfesionals([]);
        });
    }

    const allThirds = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}tercero/listar-solo-terceros`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            console.log(data);
            setThirds(data);
        }).catch((error) => {
            setThirds([]);
        });
    }

    const ProfesionalsCollapses = () => {
        let _row = [];
        try {
            profesionals.map((item, i) => _row.push(
                {
                    profesional_honorario: <div>
                        <ProfesionalCollapse
                            profesional={item}
                            className="with-shadow"
                            thirds={thirds}
                        />
                    </div>
                }
            ));
        }
        catch (e) {

        }
        return (
            <ListProfesionals reactTableData={_row} />
        );
    }

    useEffect(() => {
        allThirds();
        listProfesionals();
    }, []);

    return (
        <Container>
            <div className="tabs tabs--justify tabs--bordered-top">
                <div className="tabs__wrap">
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => toggle('1')}
                            >
                                Lista de Profesionales
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => toggle('2')}
                            >
                                Generación de Reportes y Egresos
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <div className="text-center">
                                {isLoading == false ? <ProfesionalsCollapses /> : <Spinner animation="border" variant="success" />}
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="text-center">
                                <ReportFees />
                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_fees',
})(AllFees);